import React from "react";
import { Pie } from "react-chartjs-2";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import { useTheme } from "../../utils/ThemeContext";
export const NetWorthBudgetGraph = ({goalsData,loading}) => {
    const { theme } = useTheme();
  
  const dataDonut = {
    labels: [
      "Wedding",
      "Vacation",
      "Investment Property",
      "Trip to Scotland",
      "Retirement",
      "Unallocated",
    ],
    datasets: [
      {
        data: [1600, 750, 1000, 1250, 5000, 2885],
        backgroundColor: [
          "#1E56A0",
          "#4DA1A9",
          "#3CAEA3",
          "#8AC926",
          "#A3EB80",
          "#FF5A5F",
        ],
      },
    ],
  };

  return (
    <div
      className="budgetMaincards netWorthCard"
      style={{
        width: "100%",
        padding: "20px",
        borderRadius: "8px",
        backgroundColor: theme === "dark" ? "#232323" : "white",
        position:"relative"
      }}>
      <h2 style={{ fontSize: "1.5rem", fontWeight: "bold", color: theme === "light" ? "#232323" : "white", }}>
        Goal Monthly Savings
      </h2>
      <p style={{ fontSize: "1.2rem", color: theme === "light" ? "#232323" : "white", }}>Monthly Savings Potential: $12,485</p>

      <div style={{ display: "flex", marginTop: "1rem" }}>
        <Pie
          data={dataDonut}
          options={{
            legend: {
              display: true,
              position: "right",
              labels: {
                font: {
                  size: 14,
                },
                usePointStyle: true,
              },
            },
            plugins: {},
          }}
        />
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
